export const authThemeDark = "auth-theme-dark";
export const authThemeHighlight = "auth-theme-highlight";
export const authThemeAccent = "auth-theme-accent";
